import { useLocation } from 'react-router';
import { TrackingDetails } from './types';

// for sonarqube
const PRICING_ROUTE = 'pricing';
const TEAMS_SUMMARY = 'pricing-teams-summary';
/**
 * We need to send exactly what is sent in prod now so we do not mess up existing dashboards.
 * For now, details & summary will suffice (we do not track enterprise page).
 * Do not change the object mapping without approval
 */
const PAGE_NAME_MAP: Record<string, string> = Object.freeze({
  [PRICING_ROUTE]: 'pricing summary canonical',
  [`${PRICING_ROUTE}-teams`]: 'pricing summary teams',
  [`${PRICING_ROUTE}-individual`]: 'pricing summary individual',
  [`${PRICING_ROUTE}-details`]: 'pricing details canonical',
  [`${PRICING_ROUTE}-teams-details`]: 'pricing details teams',
  [`${PRICING_ROUTE}-individual-details`]: 'pricing details individual',
  [`${PRICING_ROUTE}-educational`]: 'pricing educational',
  [`${PRICING_ROUTE}-enterprise`]: 'pricing enterprise',
  [`${PRICING_ROUTE}-ippm`]: 'pricing ippm', // GROW-2792 PnP Refresh IPPM
});

/**
 * Similar to the above, a map of generated page names to the ut_source
 * parameter that will be attached to outgoing links
 */
const UT_SOURCE_MAP: Record<string, string> = Object.freeze({
  [PRICING_ROUTE]: TEAMS_SUMMARY,
  [`${PRICING_ROUTE}-teams`]: TEAMS_SUMMARY,
  [`${PRICING_ROUTE}-details`]: 'pricing-teams-details',
  [`${PRICING_ROUTE}-individual`]: 'pricing-indv-summary',
  [`${PRICING_ROUTE}-teams-details`]: 'pricing-teams-details',
  [`${PRICING_ROUTE}-individual-details`]: 'pricing-indv-details',
  [`${PRICING_ROUTE}-educational`]: 'pricing-indv-details',
  [`${PRICING_ROUTE}-enterprise`]: TEAMS_SUMMARY, // for now we are replicating legacy billweb
  [`${PRICING_ROUTE}-enterprise-details`]: TEAMS_SUMMARY,
  [`${PRICING_ROUTE}-ippm`]: 'in_product_pricing', // GROW-2792 PnP Refresh IPPM
});

/**
 * This hook returns the tracking info we need for either @sm/metrics or amplitude.
 * This hook can be extended to support all required tracking information in the near future
 * If display name is not provided, we fall back to the route.
 * @returns TrackingDetails
 */
export default function useTrackingDetails(): TrackingDetails {
  const { pathname, search } = useLocation();
  const utSource = new URLSearchParams(search).get('ut_source');
  // strips and replaces beginning and ending forward slash in the pathname
  const pageName = pathname
    ?.replace(/\//g, '-')
    .replace(/^\W+|\W+$/gm, '')
    .trim();

  return {
    utSource,
    pageName: PAGE_NAME_MAP[pageName],
    pageUtSource: UT_SOURCE_MAP[pageName],
  };
}
